import { createSelector } from '@ngrx/store';
import { selectAuthenticationState } from '../index';
import { AuthenticationState } from '../reducer/authentication.reducer';

export const selectUser = createSelector(selectAuthenticationState, (state: AuthenticationState) => state.user);
export const selectUserList = createSelector(selectAuthenticationState, (state: AuthenticationState) => state.userList);
